export class DateUtil {
  estMemeJour(dateVerifiee: string): boolean {
    if (!dateVerifiee || dateVerifiee.trim() === '') return true;
    const [year, month, day] = dateVerifiee.trim().split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const today = new Date();
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  }
}
